import React, { useState, useMemo, useRef, useEffect } from "react";
import { Card, CardBody } from "reactstrap";
import {
  InstantSearch,
  useHits
} from "react-instantsearch";
import { createElasticsearchAdapter } from "../../utils/elasticsearchAdapter";
import {
  CustomPagination
} from "../applicant/CustomSearchComponents";
import MyPostulationsHits from "./Hits";

// HitsWrapper component to handle Instantsearch hits
const MyPostulationsHitsWrapper = ({
  hits,
  setHits
}) => {
  const { hits: instantHits } = useHits();

  useEffect(() => {
    // Convert Instantsearch hits to the format expected by MyPostulationsHits
    const convertedHits = instantHits.map(hit => {
      // Prefer _source if it exists (it's the original structure from Elasticsearch)
      let source;
      if (hit._source && Object.keys(hit._source).length > 0) {
        source = hit._source;
      } else {
        // Reconstruct _source from spread data
        const { objectID, _id, _source, ...sourceData } = hit;
        source = sourceData;
      }

      const hitId = hit._id || hit.objectID || hit.id || source?.id;

      return {
        _id: hitId,
        _source: source
      };
    });

    setHits(convertedHits);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instantHits]);

  if (hits.length === 0) {
    return (
      <div className="text-center p-4">
        <p className="text-muted">No se encontraron postulaciones</p>
      </div>
    );
  }

  return <MyPostulationsHits hits={hits} />;
};

const MyPostulationsIndex = ({ route }) => {
  const [hits, setHits] = useState([]);

  // Store sort option in a ref to avoid recreating the client
  // Default sort: most recent first
  const sortOptionRef = useRef({ field: "created_at", order: "desc" });

  // Create search client with Elasticsearch adapter
  const searchClient = useMemo(() => {
    const searchRoute = route.endsWith('/_search') ? route : `${route}/_search`;

    const adapter = createElasticsearchAdapter(searchRoute, {
      httpHeaders: { "X-CSRF-TOKEN": window.Hupe8.token },
      timeout: 20000
    });

    // Wrap the search method to inject customSort dynamically
    const originalSearch = adapter.search.bind(adapter);
    adapter.search = async (requests) => {
      const modifiedRequests = requests.map(req => ({
        ...req,
        params: {
          ...req.params,
          customSort: sortOptionRef.current
        }
      }));
      return originalSearch(modifiedRequests);
    };

    return adapter;
  }, [route]);

  return (
    <Card className="material-shadow">
      <CardBody>
        <InstantSearch
          searchClient={searchClient}
          indexName="postulations"
          future={{ preserveSharedStateOnUnmount: true }}
          routing={false}
        >
          <MyPostulationsHitsWrapper
            hits={hits}
            setHits={setHits}
          />

          {hits.length > 0 && (
            <CustomPagination />
          )}
        </InstantSearch>
      </CardBody>
    </Card>
  );
};

export default MyPostulationsIndex;
